import {combineReducers, configureStore} from '@reduxjs/toolkit'
import brandSlice from './brandSlice'
import productSlice from './productSlice'

const rootReducer = combineReducers({
    brandSlice,
    productSlice
})
const store = configureStore({
    reducer : rootReducer
})

export default store;